<template>
  <div>
    <bread-crumb></bread-crumb>
    <!-- <search @getChangeValue="getChangeValue" @clearInfos="clearInfos"></search> -->
    <manFormList
      :select="select"
      :selectList="selectList"
      @getChangeValue="getChangeValue"
      @selectChenge="selectChenge"
      @empty="empty"
      @searchFilter="searchFilter"
      @checkBoxedChange="checkBoxedChange"
      @clickSingleBoxed="clickSingleBoxed"
      @popHide="popHide"
      :searchFilterList="searchFilterList"
      :checkList="checkList"
      :num="num"
      :isBtn="isBtn"
      :isShowFilter="isShowFilter"
      @disease_remoteMethod="getDiseases"
    ></manFormList>

    <div class="content-audit-tabel">
      <el-row class="import-btn" type="flex" justify="end">
        <!-- 导出商品Export -->
        <el-button type="text" @click="dialogOutContentSkusVisibleSku = true"
          >批量导出商品
        </el-button>
        <el-button
          class="redTag"
          type="text"
          v-if="isSaleExportErrorShow"
          @click="downloadDiles(8)"
          >导出商品失败
        </el-button>
        <!-- 导入商品Import -->
        <div class="importBtn">
          <el-button type="primary" @click="dialogInContentSkusVisible = true"
            >批量导入商品
          </el-button>
        </div>
        <div class="importBtn">
          <el-button
            type="danger"
            v-if="isSaleImportErrorShow"
            @click="downloadDiles(7)"
            >导入商品失败
          </el-button>
        </div>

        <!-- 导出类目Export -->
        <el-button type="text" @click="dialogOutCategoryVisible = true"
          >批量导出类目
        </el-button>
        <el-button
          class="redTag"
          type="text"
          v-if="isExportErrorShow"
          @click="downloadDiles(5)"
          >导出类目失败
        </el-button>
        <!-- 导入类目Import -->
        <div class="importBtn">
          <el-button type="primary" @click="dialogInCategoryVisible = true"
            >批量导入类目
          </el-button>
        </div>
        <div class="importBtn">
          <el-button
            type="danger"
            v-if="isImportErrorShow"
            @click="downloadDiles(4)"
            >导入类目失败
          </el-button>
        </div>
        <!-- 导出文章 -->
        <div class="exportBtn" v-if="userInfo.tenantManager">
          <el-button
            type="primary"
            size="mini"
            @click="dialogContentVisible = true"
            >数据导出(1次最多1w条)
          </el-button>
        </div>
        <div class="importBtn">
          <el-button
            type="danger"
            v-if="isExportArticleShow"
            @click="downloadDiles(6)"
            >导出失败
          </el-button>
        </div>
      </el-row>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="全部" name="all">
          <span slot="label" class="slot-item">
            <span>全部</span><span>{{ allCount }}</span>
          </span>
          <base-table
            :tableData="tableData"
            @handleClick="TabhandleClick"
          ></base-table>
        </el-tab-pane>
        <el-tab-pane label="待审核" name="pending">
          <span slot="label" class="slot-item">
            <span>待审核</span><span>{{ unAuditCount }}</span>
          </span>
          <base-table
            :tableData="tableData"
            @handleClick="TabhandleClick"
          ></base-table>
        </el-tab-pane>
        <el-tab-pane label="待下线审核" name="offlineEview">
          <span slot="label" class="slot-item">
            <span>待下线审核</span><span>{{ offlineUnAuditCount }}</span>
          </span>
          <base-table
            :tableData="tableData"
            @handleClick="TabhandleClick"
          ></base-table>
        </el-tab-pane>
        <el-tab-pane label="已通过" name="passed">
          <span slot="label" class="slot-item">
            <span>已通过</span><span>{{ passAuditCount }}</span>
          </span>
          <base-table
            :tableData="tableData"
            @handleClick="TabhandleClick"
          ></base-table>
        </el-tab-pane>
        <el-tab-pane label="已驳回" name="rejected">
          <span slot="label" class="slot-item">
            <span>已驳回</span><span>{{ rejectCount }}</span>
          </span>
          <base-table
            :tableData="tableData"
            @handleClick="TabhandleClick"
          ></base-table>
        </el-tab-pane>
        <el-tab-pane label="已下线" name="offline">
          <span slot="label" class="slot-item">
            <span>已下线</span><span>{{ offlineCount }}</span>
          </span>
          <base-table
            :tableData="tableData"
            @handleClick="TabhandleClick"
          ></base-table>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!--导出商品-->
    <el-dialog
      title="批量导出商品"
      :visible.sync="dialogOutContentSkusVisibleSku"
      width="30%"
      @close="closeOutDialog"
    >
      <div
        style="
          margin-top: 10px;
          display: flex;
          justify-content: center;
          align-items: center;
        "
      >
        <el-button
          type="primary"
          size="medium"
          :loading="uploadShow"
          @click="getOutContentContentSkus()"
          style="width: 93px"
        >
          {{ uploadShow ? "导出中" : "导出" }}
        </el-button>
      </div>
    </el-dialog>
    <!--导入商品-->
    <el-dialog
      title="批量导入商品"
      :visible.sync="dialogInContentSkusVisible"
      width="30%"
      @close="closeDialog"
    >
      <el-button
        :disabled="isButton"
        type="primary"
        plain
        style="display: block; margin: auto"
        @click="downloadDiles(9)"
        >下载商品Excel模板
      </el-button>
      <div
        style="
          margin-top: 10px;
          display: flex;
          justify-content: center;
          align-items: center;
        "
      >
        <input type="file" @change="fileChange" ref="file" />
        <el-button
          type="primary"
          size="medium"
          :loading="uploadShow"
          @click="uploadContentSkusExl"
          style="width: 93px"
        >
          {{ uploadShow ? "上传中" : "上传" }}
        </el-button>
      </div>
      <div style="margin-top: 10px; text-align: center">
        <p>注： 1、请上传Excel文件，列表不超过1000行</p>
        <p>2、上传过程中请勿刷新</p>
      </div>
    </el-dialog>
    <!--导入类目-->
    <el-dialog
      title="批量导入类目"
      :visible.sync="dialogInCategoryVisible"
      width="30%"
      @close="closeDialog"
    >
      <el-button
        :disabled="isButton"
        type="primary"
        plain
        style="display: block; margin: auto"
        @click="downloadDiles(3)"
        >下载类目Excel模板
      </el-button>
      <div
        style="
          margin-top: 10px;
          display: flex;
          justify-content: center;
          align-items: center;
        "
      >
        <input type="file" @change="fileChange" ref="file" />
        <el-button
          type="primary"
          size="medium"
          :loading="uploadShow"
          @click="uploadCategoryExl"
          style="width: 93px"
        >
          {{ uploadShow ? "上传中" : "上传" }}
        </el-button>
      </div>
      <div style="margin-top: 10px; text-align: center">
        <p>注： 1、请上传Excel文件，列表不超过1000行</p>
        <p>2、上传过程中请勿刷新</p>
      </div>
    </el-dialog>
    <!--导出类目-->
    <el-dialog
      title="批量导出类目"
      :visible.sync="dialogOutCategoryVisible"
      width="30%"
      @close="closeOutDialog"
    >
      <div
        style="
          margin-top: 10px;
          display: flex;
          justify-content: center;
          align-items: center;
        "
      >
        <el-button
          type="primary"
          size="medium"
          :loading="uploadShow"
          @click="getOutContentCategory()"
          style="width: 93px"
        >
          {{ uploadShow ? "导出中" : "导出" }}
        </el-button>
      </div>
    </el-dialog>
    <!--导出文章-->
    <el-dialog
      title="批量导出文章"
      :visible.sync="dialogContentVisible"
      width="30%"
      @close="closeOutDialog"
    >
      <div
        style="
          margin-top: 10px;
          display: flex;
          justify-content: center;
          align-items: center;
        "
      >
        <el-button
          type="primary"
          size="medium"
          :loading="uploadShow"
          @click="getOutArticleCategory()"
          style="width: 93px"
        >
          {{ uploadShow ? "导出中" : "导出" }}
        </el-button>
      </div>
    </el-dialog>
    <pagination
      @sizePageChange="paginationChangeProduct"
      :paginationDatas="paginationDataProduct"
    ></pagination>
    <modal
      :isShow.sync="reasonFrom.seeReasonDialog"
      title="查看理由"
      width="414px"
      :isShowBtn="reasonFrom.isShowBtn"
      :btnText="reasonFrom.ordinaryBtnText"
      @clickHandler="viewReasonClick"
    >
      <el-form label-width="100px" class="demo-ruleForm">
        <div class="reasonDom">
          {{ reasonFrom.reason }}
        </div>
      </el-form>
    </modal>
    <modal
      :isShow.sync="reviewOfflineDialog"
      title="审核下线申请"
      :isShowBtn="isShowBtn"
      @one="handleDialog(false)"
      @update:isShow="handleDialog(false)"
      :btnText="btnText"
      @clickHandler="reviewOffHandler"
    >
      <el-form label-width="100px" class="demo-ruleForm">
        <div class="reasonDom">
          {{ rejectForm.applyReason }}
        </div>
      </el-form>
    </modal>

    <modal
      :isShow.sync="rejectForm.rejectlineDialog"
      title="驳回"
      :width="width"
      :isShowBtn="rejectForm.isShowBtn"
      :btnText="rejectForm.ordinaryBtnText"
      @clickHandler="rejectClickHandler"
    >
      <el-form :model="rejectForm" label-width="100px">
        <el-form-item label="驳回理由" class="freezeDom">
          <el-input
            size="small"
            type="textarea"
            placeholder="请输入驳回理由，不超过200字"
            v-model="rejectForm.rejectReasons"
            maxlength="200"
            show-word-limit
            class="freezeInp"
          >
          </el-input>
        </el-form-item>
      </el-form>
    </modal>
    <base-dialog
      :dialogShow="offlineDialogShow"
      @dialogHandel="offlineDialogHandel"
      :formData="formData"
      @closeDialog="offlineCloseDialog"
    ></base-dialog>
  </div>
</template>

<script>
import baseTable from "../../../../../components/baseTable";
// import search from "../../../components/search"
import manFormList from "../../../components/manFormList";
import breadCrumb from "../../../../../components/breadCrumb";
import pagination from "../../../../../components/pagination";
import {
  queryArticleList,
  getAllArticleCounts,
  setArticleBadgeStatus,
  setArticleTopStatus,
  passOfflineArticle,
  rejectOfflineArticle,
  manOfflineArticle,
  onlineViewArticle,
  importInArticleCategory,
  importExArticleCategory,
  importExportLog,
  listContentBusinessForUserMan,
  manSaveUserConfig,
  manListUserConfig,
} from "@/api/man";
import { queryToExamineList } from "../../../../../api/contentDistribution";
import modal from "@/components/modal";
import baseDialog from "../../../components/baseDialog";
import { getDiseasesData } from "../distribution";
import { request } from "@/utils/axios";
import {
  getDistributionScope,
  searchDataProcessing,
  getContentQuailty,
  getGeneralLabel,
} from "../distribution";
import { manListContentIndexTree } from "@/api/indexs";
import {
  getOutArticleCategory,
  uploadCategoryExl,
  fileChange,
} from "../../../components/importExportCommon";
import { mapState } from "vuex";

var selectList_bak = {
  articleId: "", //文章ID
  articleKeyWord: "", // 文章关键字
  diseaseLabel: "", // 疾病标签
  nickname: "", // 写手昵称
  writerPin: "", // 写手Pin
  doctorName: "", // 医生名字
  hospital: "", // 医院名称
  department: "", // 科室名称
  articleType: "", // 文章类型
  submissionTime: [], // 投稿时间
  auditTime: [], //
  featuredArticle: "", // 精选文章
  isOriginal: "", // 是否原创
  isTop: "", // 是否置顶
  business: [], // 所属业务
  categoryId: "", // 所属栏目
  channelId: "", // 所属频道
  categoryRelationId: "", // 类目ID
  range: "", // 分发范围
  quality: "", // 内容质量
  contentDiseasesNotNull: "",
  isDoctor: "",
  contentIndexIds: [], // 索引
  bindTask: 1,
};
export default {
  name: "contentAudit",
  data() {
    return {
      num: 3,
      rejectForm: {
        rejectlineDialog: false,
        rejectReasons: "",
        applyReason: "",
        isShowBtn: [true, true], //弹窗是否能显示按钮
        ordinaryBtnText: ["取消", "确认"],
      },
      activeName: "all",
      tableData: {
        tableList: [],
        tableHeader: [
          {
            label: "文章ID",
            prop: "id",
          },
          {
            label: "文章标题",
            prop: "title",
          },
          {
            label: "文章类型",
            prop: "articleType",
          },
          {
            label: "作者",
            prop: "creator",
          },
          {
            label: "任务名称",
            prop: "taskName",
            tableStatus: "taskName",
          },
          {
            label: "任务要求",
            prop: "taskDesc",
            tableStatus: "taskDesc",
          },
          {
            label: "悬赏金额",
            prop: "taskRewardDesc",
            tableStatus: "taskRewardDesc",
          },
          {
            label: "提交时间",
            prop: "submitTime",
          },
        ],
        tableType: 10,
      },
      paginationDataProduct: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
      articleStatus: [],
      articleListCode: 0,
      allCount: 0, // 全部
      offlineCount: 0, // 已下线
      offlineUnAuditCount: 0, // 下线待审核
      passAuditCount: 0, // 已通过
      rejectCount: 0, // 驳回
      unAuditCount: 0, // 待审核
      isShowBtn: [true, true, false],
      reviewOfflineDialog: false, // 审核下线申请
      btnText: ["驳回", "通过"],
      targetValue: null,
      isSelected: false,
      formData: {
        formList: {
          title: "下线文章",
          infoKey: "下线理由",
          infoValue: "",
          placeholder: "请输入下线理由",
          maxlength: "200",
          type: 2, //0(13\16) or 1(28)
        },
      },
      offlineDialogShow: false,
      formlist: [],
      selectList: this.$commonJs.deepClone(selectList_bak),
      reasonFrom: {
        seeReasonDialog: false,
        ordinaryBtnText: ["取消", "确认"],
        isShowBtn: [true, true], //弹窗是否能显示按钮
        reason: "",
      },
      old: {},
      isBtn: 1,
      isShowFilter: 1,
      searchFilterList: [],
      configId: null,
      checkList: [1000],
      allSearchList: [],
      serverList: [],
      contentAttributes: [],
      rangeList: [], // 分发范围
      qualityList: [], // 内容质量
      businessList: [],
      articleLabels: [], // 内容标签
      businessChannelArr: [],
      select: [
        {
          prop: "articleId",
          type: "input2",
          placeholder: "请输入文章ID进行检索",
          maxLenth: 18,
        },
      ],
      select1: [
        {
          prop: "articleId",
          type: "input2",
          placeholder: "请输入文章ID进行检索",
          maxLenth: 18,
        },
        {
          prop: "articleKeyWord",
          type: "input",
          placeholder: "请输入标题关键词检索",
          maxLenth: 50,
        },
        {
          prop: "diseaseLabel",
          type: "disease",
          placeholder: "请输入疾病",
          List: [],
        },
        {
          prop: "nickname",
          type: "input",
          placeholder: "请输入写手昵称进行检索",
          maxLenth: 50,
        },
        {
          prop: "writerPin",
          type: "input",
          placeholder: "请输入写手Pin进行检索",
          maxLenth: 50,
        },
        {
          prop: "doctorName",
          type: "input",
          placeholder: "请输入医生姓名进行检索",
          maxLenth: 50,
        },
        {
          prop: "hospital",
          type: "input",
          placeholder: "请输入医院名称进行检索",
          maxLenth: 50,
        },
        {
          prop: "department",
          type: "input",
          placeholder: "请输入科室名称进行检索",
          maxLenth: 50,
        },
        {
          prop: "articleType",
          type: "select",
          placeholder: "请选择文章类型检索",
          List: [
            {
              value: 1,
              label: "图文",
            },
            {
              value: 7,
              label: "视频",
            },
          ],
        },
        {
          prop: "submissionTime",
          type: "picker",
          placeholder: "请选择投稿时间",
          //   List:[]
        },
        {
          prop: "featuredArticle",
          type: "select",
          placeholder: "是否精选",
          List: [
            {
              value: 2,
              label: "是",
            },
            {
              value: 1,
              label: "否",
            },
          ],
        },
        {
          prop: "isOriginal",
          type: "select",
          placeholder: "是否原创",
          List: [
            {
              value: 1,
              label: "是",
            },
            {
              value: 2,
              label: "否",
            },
          ],
        },
        {
          prop: "isTop",
          type: "select",
          placeholder: "是否置顶",
          List: [
            {
              value: 0,
              label: "全部",
            },
            {
              value: 1,
              label: "置顶",
            },
          ],
        },
        {
          prop: "business",
          type: "select",
          placeholder: "请输入所属业务",
          List: [],
        },
        {
          prop: "categoryId",
          type: "select",
          placeholder: "请输入所属栏目",
          List: [],
        },
        {
          prop: "channelId",
          type: "select",
          placeholder: "请输入所属频道",
          List: [],
        },
        {
          prop: "categoryRelationId",
          type: "input",
          placeholder: "请输入类目ID进行检索",
          maxLenth: 50,
        },
        {
          prop: "keyWords",
          type: "input",
          placeholder: "请输入全文关键词检索",
          maxLenth: 50,
        },
        {
          prop: "contentIndexIds",
          type: "selectIndex",
          placeholder: "请选择索引",
          List: [],
        },
      ],
      isButton: false,
      uploadShow: false,
      timer: null,
      //类目导入失败
      isImportErrorShow: false,
      failImportUrl: "",
      // 商品倒入失败
      isSaleImportErrorShow: false,
      failImportSaleUrl: "",
      //类目导出失败
      isExportErrorShow: false,
      failExportUrl: "",
      //商品导出失败
      isSaleExportErrorShow: false,
      failExportSaleUrl: "",
      // 导出文章失败
      isExportArticleShow: false,
      failExportArticleUrl: "",
      // ------------------- 批量导入 start ---------------------
      // 导出商品弹出是否显示标识
      dialogOutContentSkusVisibleSku: false,
      // 导入商品弹出是否显示标识
      dialogInContentSkusVisible: false,
      // 导入类目弹出是否显示标识
      dialogInCategoryVisible: false,
      // 导出类目弹出是否显示标识
      dialogOutCategoryVisible: false,
      // 批量上传
      fileList: [],
      dialogContentVisible: false,
      // ------------------- 批量导入 end ---------------------
      murl: "",
    };
  },
  components: {
    // search,
    manFormList,
    breadCrumb,
    baseTable,
    pagination,
    modal,
    baseDialog,
  },
  async created() {
    // console.log('开始=========》');
    // 查询用户保存配置
    await this.queryUserConfig();
    //  获取天空之城数据
    await this.queryFloorList();
    //  console.log('结束=========》');
    // 获取分发范围
    this.getDistributionScope();
    // 获取内容质量
    this.getContentQuailty();
    // 是否由文章详情页跳转本页面
    this.initializeJump();
    // sessionStorage获取tabpane的状态
    this.getSessionStorageInfo();
    // this.getArticleList()
    this.listContentBusinessForUserMan();
    // 获取标签
    this.getGeneralLabel();
    this.getIndexTreeList();
  },
  mounted() {
    this.$nextTick(() => {
      // 添加这段代码
      const $el = document.querySelectorAll(
        ".el-cascader-panel .el-cascader-node[aria-owns]"
      );
      Array.from($el).map((item) => item.removeAttribute("aria-owns"));
    });
  },
  destroyed() {
    // 销毁详情跳跳转存储
    sessionStorage.removeItem("content");
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
  computed: {
    ...mapState(["imgHost", "userInfo"]),
  },
  methods: {
    recursionObj(node, callback, judge) {
      if (judge(node)) {
        node = callback(node);
      }
      if (!node.contentIndexes || node.contentIndexes.length === 0) {
        return;
      }
      for (let i = 0; i < node.contentIndexes.length; i++) {
        if (judge(node)) {
          this.recursionObj(node.contentIndexes[i], callback, () => true);
        } else {
          this.recursionObj(node.contentIndexes[i], callback, judge);
        }
      }
      return;
    },
    // 获取索引下拉数据
    getIndexTreeList() {
      manListContentIndexTree().then((res) => {
        // 处理树的叶子结点
        for (let i = 0; i < res.length; i++) {
          this.recursionObj(
            res[i],
            (curNode) => {
              curNode.contentIndexes = undefined;
              return curNode;
            },
            (node) => node.contentIndexes.length === 0
          );
        }
        this.indexTreeList = res;
        this.select.map((subItem) => {
          if (subItem.prop == "contentIndexIds") {
            subItem.List = res;
          }
        });
      });
    },
    // 上传弹窗关闭
    closeDialog() {
      let fileVal = this.$refs.file;
      fileVal.value = "";
      this.fileResult = "";
      this.fileName = "";
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    //导出弹窗关闭
    closeOutDialog() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    // 下载模板或失败数据
    downloadDiles(type) {
      if (type == 3) {
        this.isButton = true;
        window.open(
          "//storage.360buyimg.com/cms-bucket/ImportTemplate/%E5%AF%BC%E5%85%A5%E5%86%85%E5%AE%B9%E5%85%B3%E8%81%94%E7%B1%BB%E7%9B%AE%E6%A8%A1%E6%9D%BF.xlsx?Expires=3810106704&AccessKey=Jd9HhkNEAtwojp2B&Signature=XtmgTIEu8TAo8ygsLoa1GfgZ%2Faw%3D"
        );
        setTimeout(() => {
          this.isButton = false;
        }, 3000);
      }
      if (type == 4) {
        window.open(this.failImportUrl);
        this.isImportErrorShow = false;
      }
      if (type == 5) {
        window.open(this.failExportUrl);
        this.isExportErrorShow = false;
      }
      if (type == 7) {
        window.open(this.failImportSaleUrl);
        this.isSaleImportErrorShow = false;
      }
      if (type == 8) {
        window.open(this.failExportSaleUrl);
        this.isSaleExportErrorShow = false;
      }
      if (type == 6) {
        window.open(this.failExportArticleUrl);
        this.isExportArticleShow = false;
      }
      if (type === 9) {
        this.isButton = true;
        window.open(
          "//storage.jd.com/cms-bucket/importExcel/9/ImportTemplate/contentSkuImportTemplate.xlsx?Expires=3833524642&AccessKey=Jd9HhkNEAtwojp2B&Signature=txKqNOai4LeYgVImYsd%2BzzU92RI%3D"
        );
        setTimeout(() => {
          this.isButton = false;
        }, 3000);
      }
    },
    // 上传文件校验
    async fileChange(e) {
      fileChange(e, this);
    },
    // 上传类目
    async uploadCategoryExl() {
      uploadCategoryExl(this, 1);
    },
    // 文章导出
    getOutArticleCategory() {
      getOutArticleCategory(this, 5);
    },
    // 导出类目
    async getOutContentCategory() {
      getOutArticleCategory(this, 1);
    },
    // 导出商品
    async getOutContentContentSkus() {
      getOutArticleCategory(this, 9);
    },
    // 上传商品
    async uploadContentSkusExl() {
      uploadCategoryExl(this, 9);
    },
    // 查询疾病库名称
    getDiseases(val) {
      getDiseasesData(val, this);
    },
    // 回到列表页 跳转
    initializeJump() {
      if (sessionStorage.getItem("content")) {
        this.paginationDataProduct.currentPage =
          sessionStorage.getItem("currentPage");
        this.selectList = JSON.parse(sessionStorage.getItem("select"));
        this.select = JSON.parse(sessionStorage.getItem("selectList"));
      } else {
        this.paginationDataProduct.currentPage = 1;
        this.selectList = selectList_bak;
        this.isSelected = false;
        //  改版注掉
        // this.select[14].List = []
        // this.select[15].List = []
        this.selectList = this.$commonJs.deepClone(selectList_bak); // 清空
      }
    },
    // 跳转存储信息
    setStorage() {
      // 跳转页面存储当前页码
      sessionStorage.setItem(
        "currentPage",
        this.paginationDataProduct.currentPage
      );
      sessionStorage.setItem("activeName", this.activeName);
      let selectStr = JSON.stringify(this.selectList);
      let selectList = JSON.stringify(this.select);
      sessionStorage.setItem("selectList", selectList);
      sessionStorage.setItem("select", selectStr);
    },
    getSessionStorageInfo() {
      this.activeName = sessionStorage.getItem("activeName") || "all";
      if (this.activeName === "all") {
        this.articleListCode = 0;
      } else if (this.activeName === "pending") {
        this.articleListCode = 2;
      } else if (this.activeName === "offlineEview") {
        this.articleListCode = 7;
      } else if (this.activeName === "passed") {
        this.articleListCode = 3;
      } else if (this.activeName === "rejected") {
        this.articleListCode = 4;
      } else if (this.activeName === "offline") {
        this.articleListCode = 5;
      }
      this.articleStatus = [];
      if (this.articleListCode !== 0) {
        this.articleStatus.push(this.articleListCode);
      }
      this.getArticleList();
    },
    handleClick(tab, event) {
      sessionStorage.setItem("activeName", tab.name);
      this.paginationDataProduct = {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      };
      // this.getArticleList()
      if (this.activeName === "all") {
        this.articleListCode = 0;
      } else if (this.activeName === "pending") {
        this.articleListCode = 2;
      } else if (this.activeName === "offlineEview") {
        this.articleListCode = 7;
      } else if (this.activeName === "passed") {
        this.articleListCode = 3;
      } else if (this.activeName === "rejected") {
        this.articleListCode = 4;
      } else if (this.activeName === "offline") {
        this.articleListCode = 5;
      }
      this.articleStatus = [];
      if (this.articleListCode !== 0) {
        this.articleStatus.push(this.articleListCode);
      }

      this.getArticleList();
    },
    TabhandleClick(val) {
      if (val.type === "edit") {
        this.setStorage();
        // 跳转到文章编辑页面
        this.$router.push({
          path: `/contentAudit/contentedit`,
          query: {
            id: val.val.id,
            actionType: 1,
            articleType: val.val.articleType,
            requestSource: 1,
            labelGroupId: this.$route.query.labelGroupId || undefined,
            taskFlag: true,
          },
        });
      } else if (val.type === "review") {
        this.setStorage();
        // 跳转到文章编辑页面
        this.$router.push({
          path: `/contentAudit/contentedit`,
          query: {
            id: val.val.id,
            labelGroupId: this.$route.query.labelGroupId || undefined,
            requestSource: 2,
            taskFlag: true,
          },
        });
      } else if (val.type === "featured") {
        // 设置精选
        val.val.badge === 1
          ? this.setArticleBadgeStatus(2, val.val.id)
          : this.setArticleBadgeStatus(1, val.val.id);

        // this.getArticleList()
      } else if (val.type === "watchOnline") {
        onlineViewArticle({
          tenantId: this.$commonJs.getTenantId(),
          conentId: val.val.id,
          contentType: val.val.articleType,
        }).then((res) => {
          // 跳转线上文章页面
          window.open(res.mUrl);
        });
      } else if (val.type === "offline") {
        this.offlineDialogShow = true;
      } else if (val.type === "reason") {
        if (val.val.rejectReason) {
          this.reasonFrom.reason = val.val.rejectReason;
        } else if (val.val.offlineReason) {
          this.reasonFrom.reason = val.val.offlineReason;
        }
        this.reasonFrom.seeReasonDialog = true;
      } else if (val.type === "offlineApplication") {
        //
        this.rejectForm.applyReason = val.val.remark;
        this.reviewOfflineDialog = true;
      } else if (val.type === "top") {
        // 置顶
        var tipStr = val.val.isTop === 0 ? "置顶" : "取消置顶";
        this.$confirm(`确定要${tipStr}吗？`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            setArticleTopStatus({
              id: val.val.id, // 文章id  Integer 是
              isTop: val.val.isTop === 0 ? 1 : 0, // 置顶状态，1置顶，0取消置顶  Integer 是
              tenantId: this.$commonJs.getTenantId(),
            }).then((res) => {
              this.getArticleList();
              this.$message({
                type: "success",
                message: `${tipStr}成功!`,
              });
            });
          })
          .catch((e) => {
            console.log(e);
          });
      }
      this.getTargetValue(val.val);
      this.getArticleList();
    },
    paginationChangeProduct(val) {
      this.paginationDataProduct = val;
      this.getArticleList("pageChange");
    },
    // 设置精选
    setArticleBadgeStatus(badge, id) {
      setArticleBadgeStatus({
        tenantId: this.$commonJs.getTenantId(),
        id: id,
        badge: badge,
      }).then((res) => {
        this.getArticleList();
      });
    },
    // 导出请求参数方法
    exFormData() {
      if (this.selectList.range != "" || this.selectList.quality != "") {
        this.searchDataProcessing();
      }
      let arr = [];
      if (this.selectList.articleLabel) {
        this.selectList.articleLabel.map((item) => {
          arr.push(item[item.length - 1]);
        });
      }
      // debugger
      let searchArticleTypes = [];
      //bugfix:文章类型必须是数组 否则接口报错
      console.log(this.selectList.actionType);
      this.selectList.articleType && this.selectList.articleType != "全部"
        ? searchArticleTypes.push(this.selectList.articleType)
        : "";
      const contentIndexIds =
        this.selectList?.contentIndexIds?.map(
          (item) => item[item?.length - 1]
        ) || [];
      let parameter = {
        tenantId: this.$commonJs.getTenantId(),
        id: this.selectList.articleId || null,
        title: this.selectList.articleKeyWord || null,
        keyWords: this.selectList.keyWords || null,
        diseaseIds: this.selectList.diseaseLabel
          ? [this.selectList.diseaseLabel]
          : [],
        nickName: this.selectList.nickname || null, //bugfix: nickname 字段取了大写
        originalAuthorName: this.selectList.doctorName || null,
        userPin: this.selectList.writerPin || null,
        originalAuthorUnit: this.selectList.hospital || null,
        originalAuthorDepart: this.selectList.department || null,
        articleTypes: searchArticleTypes || null,
        startSubmitTime:
          (this.selectList.submissionTime &&
            this.selectList.submissionTime[0]) ||
          null,
        endSubmitTime:
          (this.selectList.submissionTime &&
            this.selectList.submissionTime[1]) ||
          null,
        startAuditTime:
          (this.selectList.auditTime && this.selectList.auditTime[0]) || null,
        endAuditTime:
          (this.selectList.auditTime && this.selectList.auditTime[1]) || null,
        contentAttributes: this.contentAttributes || [], // 内容属性
        contentLabelIds: arr || [],
        badge:
          this.selectList.featuredArticle &&
          this.selectList.featuredArticle != "全部"
            ? this.selectList.featuredArticle
            : null,
        articleSource:
          this.selectList.isOriginal && this.selectList.isOriginal != "全部"
            ? this.selectList.isOriginal
            : null,
        page: this.paginationDataProduct.currentPage,
        pageSize: this.paginationDataProduct.pageSize,
        articleStatus: this.articleStatus,
        isTop: this.selectList.isTop == 0 ? "" : 1 || null,
        businessIds:
          typeof this.selectList.business == "number"
            ? [this.selectList.business]
            : this.selectList.business || [],
        contentCategoryIds:
          typeof this.selectList.categoryId == "number"
            ? [this.selectList.categoryId]
            : this.selectList.categoryId || [],
        contentChannelIds:
          typeof this.selectList.channelId == "number"
            ? [this.selectList.channelId]
            : this.selectList.channelId || [],
        categoryRelationIds: this.selectList.categoryRelationId
          ? [this.selectList.categoryRelationId]
          : [],
        auditUser: this.selectList.auditUser || null,
        contentDiseasesNotNull:
          this.selectList.contentDiseasesNotNull &&
          this.selectList.contentDiseasesNotNull != "全部"
            ? this.selectList.contentDiseasesNotNull
            : null,
        isDoctor:
          this.selectList.isDoctor && this.selectList.isDoctor != "全部"
            ? this.selectList.isDoctor
            : null,
        contentIndexIds,
      };
      return parameter;
    },
    //获取文章列表
    getArticleList(type) {
      if (this.selectList.range != "" || this.selectList.quality != "") {
        this.searchDataProcessing();
      }
      let arr = [];
      if (this.selectList.articleLabel) {
        this.selectList.articleLabel.map((item) => {
          arr.push(item[item.length - 1]);
        });
      }
      // debugger
      let searchArticleTypes = [];
      //bugfix:文章类型必须是数组 否则接口报错
      console.log("this.selectList.bindTask", this.selectList.bindTask);
      this.selectList.articleType && this.selectList.articleType != "全部"
        ? searchArticleTypes.push(this.selectList.articleType)
        : "";
      const contentIndexIds =
        this.selectList?.contentIndexIds?.map(
          (item) => item[item?.length - 1]
        ) || [];
      let params = {
        tenantId: this.$commonJs.getTenantId(),
        id: this.selectList.articleId || null,
        title: this.selectList.articleKeyWord || null,
        keyWords: this.selectList.keyWords || null,
        diseaseIds: this.selectList.diseaseLabel
          ? [this.selectList.diseaseLabel]
          : [],
        nickName: this.selectList.nickname || null, //bugfix: nickname 字段取了大写
        originalAuthorName: this.selectList.doctorName || null,
        userPin: this.selectList.writerPin || null,
        originalAuthorUnit: this.selectList.hospital || null,
        originalAuthorDepart: this.selectList.department || null,
        articleTypes: searchArticleTypes || null,
        startSubmitTime:
          (this.selectList.submissionTime &&
            this.selectList.submissionTime[0]) ||
          null,
        endSubmitTime:
          (this.selectList.submissionTime &&
            this.selectList.submissionTime[1]) ||
          null,
        startAuditTime:
          (this.selectList.auditTime && this.selectList.auditTime[0]) || null,
        endAuditTime:
          (this.selectList.auditTime && this.selectList.auditTime[1]) || null,
        contentAttributes: this.contentAttributes || [], // 内容属性
        contentLabelIds: arr || [],
        badge:
          this.selectList.featuredArticle &&
          this.selectList.featuredArticle != "全部"
            ? this.selectList.featuredArticle
            : null,
        articleSource:
          this.selectList.isOriginal && this.selectList.isOriginal != "全部"
            ? this.selectList.isOriginal
            : null,
        page: this.paginationDataProduct.currentPage,
        pageSize: this.paginationDataProduct.pageSize,
        articleStatus: this.articleStatus,
        isTop: this.selectList.isTop == 0 ? "" : 1 || null,
        businessIds:
          typeof this.selectList.business == "number"
            ? [this.selectList.business]
            : this.selectList.business || [],
        contentCategoryIds:
          typeof this.selectList.categoryId == "number"
            ? [this.selectList.categoryId]
            : this.selectList.categoryId || [],
        contentChannelIds:
          typeof this.selectList.channelId == "number"
            ? [this.selectList.channelId]
            : this.selectList.channelId || [],
        categoryRelationIds: this.selectList.categoryRelationId
          ? [this.selectList.categoryRelationId]
          : [],
        auditUser: this.selectList.auditUser || null,
        contentDiseasesNotNull:
          this.selectList.contentDiseasesNotNull &&
          this.selectList.contentDiseasesNotNull != "全部"
            ? this.selectList.contentDiseasesNotNull
            : null,
        isDoctor:
          this.selectList.isDoctor && this.selectList.isDoctor != "全部"
            ? this.selectList.isDoctor
            : null,
        contentIndexIds,
        contentExtendParam: {
          bindTask: this.selectList.bindTask == 1 ? true : false,
        },
      };
      if (this.isSelected && type == "pageChange") {
        console.log(
          "🚀 ~ file: taskContentAudit.vue:1074 ~ getArticleList ~ pageChange:"
        );

        params = {
          ...params,
          id: null,
          title: null,
          diseaseIds: null,
          categoryRelationIds: null,
          nickName: null, //bugfix: nickname 字段取了大写
          originalAuthorName: null,
          userPin: null,
          originalAuthorUnit: null,
          originalAuthorDepart: null,
          articleTypes: null,
          beginTime: null,
          endTime: null,
          badge: null,
          articleSource: null,
          isTop: null,
          businessIds: [],
          contentCategoryIds: [],
          contentChannelIds: [],
          ...this.old,
        };
      }

      console.log(
        "🚀 ~ file: taskContentAudit.vue:1099 ~ queryToExamineList ~ params:",
        params
      );
      queryToExamineList(params).then((res) => {
        this.tableData.tableList.splice(0, this.tableData.tableList.length);
        res.data.map((item) => {
          item.realyName = item.contentUser?.nickName || "";
          this.tableData.tableList.push(item);
        });
        this.paginationDataProduct.total = res.totalCount;
        this.paginationDataProduct.currentPage = res.pageNo;
        this.paginationDataProduct.pageSize = res.pageSize;
        if (type != "pageChange" && this.isSelected) {
          this.isSelected = false;
        }
      });
      // 获取各个审核状态的文章的数量
      getAllArticleCounts(params).then((res) => {
        this.allCount = res.allCount;
        this.unAuditCount = res.unAuditCount;
        this.passAuditCount = res.passAuditCount;
        this.rejectCount = res.rejectCount;
        this.offlineCount = res.offlineCount;
        this.offlineUnAuditCount = res.offlineUnAuditCount;
      });
    },

    handleDialog(val) {
      this.reviewOfflineDialog = val;
    },
    getTargetValue(target) {
      this.targetValue = target;
    },
    reviewOffHandler(type) {
      if (type === "one") {
        this.reviewOfflineDialog = false;
        this.rejectForm.rejectlineDialog = true;
      } else if (type === "two") {
        //审核通过下线文章 --------------------- done
        passOfflineArticle({
          tenantId: this.$commonJs.getTenantId(),
          articleId: this.targetValue.id,
        })
          .then((res) => {
            this.reviewOfflineDialog = false;
            this.$message({
              message: "审核通过下线成功",
              type: "success",
            });
            this.getArticleList();
          })
          .catch((error) => {
            this.$message.error("审核通过未能成功下线");
          });
      }
    },
    offlineDialogHandel(data) {
      this.offlineDialogShow = data;
    },
    offlineCloseDialog(type) {
      // if(this.formData.formList.infoValue) {

      // } else {
      //   this.$message.error('请输入下线理由')
      // }
      if (type === "success") {
        // formData.formList.infoValue
        if (this.$utils.isEmpty(this.formData.formList.infoValue)) {
          return this.$message.error("请输入下线理由");
        } else {
          // 运营下线 --------------------done
          manOfflineArticle({
            tenantId: this.$commonJs.getTenantId(),
            articleId: this.targetValue.id,
            remark: this.formData.formList.infoValue,
          })
            .then((res) => {
              this.$message({
                message: "下线成功",
                type: "success",
              });
              this.offlineDialogShow = false;
              this.getArticleList();
              // window.location.reload(); // 刷新页面
            })
            .catch((error) => {
              this.$message.error("未能成功下线");
            });
        }
      } else {
        this.offlineDialogShow = false;
      }
    },
    //查询当前运营所有的业务
    listContentBusinessForUserMan() {
      listContentBusinessForUserMan({
        tenantId: this.$commonJs.getTenantId(),
      }).then((res) => {
        res?.contentBusinesses?.forEach((item) => {
          // 改版注掉f
          // this.select[13].List.push({
          //   label: item.name,
          //   value: item.id
          // })
          this.businessList.push({
            label: item.name,
            value: item.id,
          });
          this.select.map((subItem) => {
            if (subItem.prop == "business" && subItem.cfgID == 4000) {
              subItem.List.push({
                label: item.name,
                value: item.id,
              });
            }
            return subItem;
          });
        });
      });
    },
    getGeneralLabel() {
      getGeneralLabel(this);
    },
    // 清空筛选
    empty(data) {
      this.selectList = selectList_bak;
      this.isSelected = false;
      Object.keys(this.selectList).map((item) => {
        console.log("item=++++++++++++++++++++++++++++++++++", item);
        if (item === "contentIndexIds") {
          this.selectList[item] = [];
        } else {
          this.selectList[item] = "";
        }
      });
      // this.select[14].List = []
      // this.select[15].List = []
      this.contentAttributes = [];
      this.selectList = this.$commonJs.deepClone(selectList_bak); // 清空
      this.getArticleList(); //bugfix:清空后没有分页请求数据 造成清空后 页面没有变化
    },
    // 过滤
    searchFilter() {},
    // 配置项勾选
    checkBoxedChange(value) {},
    // 点击
    clickSingleBoxed(checked, item) {
      console.log("clickSingleBoxed======>", checked, item);
      if (checked) {
        // 添加
        if (item.cfgID == 4000) {
          this.businessChannelArr.map((busItem) => {
            this.configSubItem(busItem);
            this.select.push(busItem);
          });
          this.checkList.push(item.cfgID);
        } else {
          this.checkList.push(item.cfgID);
          this.configSubItem(item);
          this.select.push(item);
        }
      } else {
        // 删除
        this.checkList = this.checkList.filter((value) => {
          if (value == item.cfgID) return false;
          return true;
        });
        if (item.cfgID == 4000) {
          this.businessChannelArr.map((busItem) => {
            busItem.List = [];
            this.selectList[busItem.prop] = "";
          });
        } else {
          this.selectList[item.prop] = "";
        }
        this.select = this.select.filter((value) => {
          if (value.cfgID == item.cfgID) return false;
          return true;
        });
      }
    },
    configSubItem(subItem) {
      if (subItem.cfgID == 3004) {
        let arr = this.qualityList.map((item) => {
          return { value: item.id, label: item.desc };
        });
        subItem.List = arr;
      }
      if (subItem.cfgID == 3003) {
        let arr = this.rangeList.map((item) => {
          return { value: item.id, label: item.desc };
        });
        subItem.List = arr;
      }
      if (subItem.cfgID == 4000 && subItem.prop == "business") {
        subItem.List = this.businessList;
      }
      if (subItem.cfgID == 4001) {
        subItem.List = this.articleLabels;
      }
      if (subItem.cfgID == 4002) {
        subItem.List = this.indexTreeList;
      }
    },
    // 配置项隐藏
    popHide(value) {
      console.log(value, "contentAudit--popHide");
      this.saveUserConfig({
        configId: this.configId,
        tenantId: this.$commonJs.getTenantId(),
        configCode: "1",
        sceneCode: "10",
        value: value.toString(),
      });
    },
    // 获取天空之城数据 生成页面数据
    async queryFloorList() {
      // console.log('queryFloorList=======>', 33333);
      await request("jdh_laputa_queryFloorList", {
        functionId: "bandTaskContent",
        appId: "21557c5d3d0a4ec1b0184719022bb4b5",
        osName: "jdhwiki",
        venderId: null,
        inquiryTenancyId: null,
        version: 3,
      })
        .then(async (res) => {
          console.log(
            res?.cf?.floorTransferDTOS[0],
            "contentAudit<----来了哥----->"
          );
          //  处理天空之城数据
          const cfgArray = res?.cf?.floorTransferDTOS[0].cfgList.filter(
            (item) => {
              if (item?.name == "manuDataCfg") {
                return true;
              }
              return false;
            }
          );
          // console.log(cfgArray, 'contentAudit<----来了哥----->cfgArray');
          // 整体配置数据
          let valueArray = JSON.parse(cfgArray[0].value).map((item) => {
            return JSON.parse(item?.value);
          });
          let fileterArray = [];
          let allShowSearchArr = [];
          // 所有配置的数据 包括 ids
          valueArray.map((item) => {
            let filerItem = this.$commonJs.deepClone(item);
            console.log(
              "🚀 ~ file: taskContentAudit.vue:1339 ~ valueArray.map ~ filerItem:",
              filerItem,
              valueArray
            );
            if (!Array.isArray(filerItem?.selectedIDs)) {
              // 获取搜索筛选总的展示
              filerItem.selectItems = filerItem?.selectItems.filter(
                (subItem) => {
                  return subItem.isShow;
                }
              );
              fileterArray.push(filerItem);

              item.selectItems = item?.selectItems.map((subItem) => {
                if (subItem.cfgID == 4000) {
                  this.businessChannelArr.push(subItem);
                }
                return subItem;
              });
              allShowSearchArr.push(item);
            } else {
              if (this.serverList?.length == 0) {
                // console.log('默认id', 'itemSelectedIDs========>');
                this.checkList = item?.selectedIDs;
              }
            }
          });

          console.log(
            fileterArray,
            "valueArray=====>|||||allShowSearchArr",
            allShowSearchArr
          );
          this.allSearchList = allShowSearchArr;
          // 搜索筛选弹框展示的数据
          this.searchFilterList = fileterArray;
          // console.log(valueArray, '拿到我配置的数据');

          // 页面上展示搜索
          let tempSelectList = [];
          this.checkList?.map((cItem) => {
            allShowSearchArr.map((item) => {
              item?.selectItems?.map((subItem) => {
                if (cItem == subItem.cfgID) {
                  tempSelectList.push(subItem);
                }
              });
            });
          });
          // 显示的搜索弹框
          this.select = tempSelectList;
          console.log(tempSelectList, "tempSelectList=====>|||||");
        })
        .catch((err) => {
          this.$message.error(err.msg || "查询失败");
        });
      // console.log('queryFloorList=======>', 44444);
    },
    // 查询用户配置
    async queryUserConfig() {
      // console.log('queryUserConfig=======>', 11111);
      await manListUserConfig({
        tenantId: this.$commonJs.getTenantId(),
        configCode: "1",
        sceneCode: "10",
      }).then((res) => {
        if (res && res?.length > 0) {
          const userConfigBizDTO = res[0];
          this.configId = userConfigBizDTO?.configId;
          // console.log(this.configId,userConfigBizDTO, 'configId=====>',userConfigBizDTO?.value.split(','));
          this.checkList = userConfigBizDTO?.value
            .split(",")
            .map((item) => parseInt(item));
          this.serverList = userConfigBizDTO?.value
            .split(",")
            .map((item) => parseInt(item));
        }
        console.log("queryUserConfig=======>", res);
      });
      // console.log('queryUserConfig=======>', 222222);
    },
    // 用户保存配置
    async saveUserConfig(body) {
      await manSaveUserConfig(body).then((res) => {
        console.log(res, "用户保存了==========>");
      });
    },
    selectChenge(data) {
      this.isSelected = true;
      this.old = data;
    },
    //查询操作
    getChangeValue(data) {
      if (!this.$utils.checkNumber(this.selectList.articleId)) {
        return this.$message({
          message: "ID只能为数字类型",
          type: "warning",
        });
      }
      this.paginationDataProduct.currentPage = 1;
      // this.formlist=data //赋值操作
      this.getArticleList();
    },
    //驳回
    rejectClickHandler(arg) {
      if (arg === "two") {
        if (this.rejectForm.rejectReasons.length === 0) {
          this.$message.error("驳回理由不能为空");
        } else {
          rejectOfflineArticle({
            tenantId: this.$commonJs.getTenantId(),
            articleId: this.targetValue.id,
            remark: this.rejectForm.rejectReasons,
          })
            .then((res) => {
              this.$message({
                message: "成功驳回",
                type: "success",
              });
              this.getArticleList();
            })
            .catch((error) => {
              this.$message.error("驳回失败");
            });
        }
        this.rejectForm.rejectReasons = ""; //置空驳回原因
        this.rejectForm.rejectlineDialog = false;
      } else {
        this.rejectForm.rejectlineDialog = false;
        this.rejectForm.rejectReasons = ""; //置空驳回原因
      }
    },
    //查看理由
    viewReasonClick(arg) {
      this.reasonFrom.seeReasonDialog = false;
      this.reasonFrom.reason = "";
    },
    // 查询分发范围
    getDistributionScope() {
      getDistributionScope(this);
    },
    getContentQuailty() {
      getContentQuailty(this);
    },
    // 内容性质、文章级别、内容分发数据统一梳理方法
    dataTraversal(list, name) {
      list.map((item) => {
        if (item.id == name) {
          let arr = {};
          arr.code = item.code;
          arr.type = item.type;
          this.contentAttributes.push(arr);
        }
      });
    },
    // 搜索内容属性处理
    searchDataProcessing() {
      searchDataProcessing(this);
    },
  },
};
</script>

<style lang="scss" scoped>
.content-audit-tabel {
  position: relative;
  background: rgba(255, 255, 255, 1);
  border-radius: 4px;
  background: white;
  margin-top: 14px;
  .import-btn {
    position: absolute;
    right: 20px;
    top: 20px;
    z-index: 11;
    .redTag {
      color: red;
    }
  }
}

.slot-item {
  span {
    margin: 0px 2px 0px 2px;
  }
}

:deep(.el-textarea__inner) {
  min-height: 130px !important;
  resize: none;
}

:deep(.el-form-item) {
  margin-bottom: 22px;
}

:deep(.modal-body) {
  margin-top: 30px;
}

.reasonDom {
  padding: 0 30px;
  height: 100px;
  line-height: 20px;
  font-size: 14px;
  color: rgba(44, 52, 67, 1);
  /*overflow: hidden;*/
  overflow-y: auto;
  max-height: 150px;
}

.freezeDom {
  /*margin-top: 30px;*/
  .freezeInp {
    max-height: 130px;
    max-width: 276px;
    // overflow: hidden;
    .el-input__count {
      background: rgba(0, 0, 0, 0);
      bottom: -30px;
    }
  }

  .mar-top30 {
    margin-top: 30px;
  }
}
.importBtn {
  display: inline-flex;
  align-items: flex-start;
  justify-content: center;
  margin-left: 5px;
}
.exportBtn {
  margin-left: 5px;
  span {
    margin-top: 5px;
    display: block;
    color: #abaaaa;
  }
}
</style>
